module.exports = {"140411001":"长北街道","140411002":"故县街道","140411100":"老顶山镇","140411101":"堠北庄镇","140411102":"大辛庄镇","140411103":"马厂镇","140411104":"黄碾镇","140411200":"西白兔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140411.json
// module id = 257
// module chunks = 0